var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPipeline02 = function SvgPipeline02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "pipeline-02_svg__svg-icon"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#pipeline-02_svg__a)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24c6.627 0 12-5.373 12-12S18.627 0 12 0 0 5.373 0 12s5.373 12 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.508 5.112H14.23a1.016 1.016 0 0 0 0 2.03h2.278a1.016 1.016 0 0 0 0-2.03Zm-2.446 10.986c0 .806-.683 1.456-1.498 1.4-.566-.038-1.022-.423-1.21-.932H8.598c.26 1.981 1.895 3.569 3.936 3.631a4.103 4.103 0 0 0 4.222-4.098V7.733H14.06v8.366l.002-.001Zm-5.63-2.736h2.795a3.629 3.629 0 0 0-3.6-3.156H6.396v2.696h1.231c.342 0 .642.185.804.461v-.001Zm3.634 1.6c0 .561-.455 1.016-1.015 1.016H8.772a1.016 1.016 0 0 1 0-2.03h2.279c.56 0 1.015.454 1.015 1.015Zm-8.293-4.578a1.016 1.016 0 0 1 2.03 0v2.278a1.016 1.016 0 0 1-2.03 0v-2.278Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "pipeline-02_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M0 0h24v24H0z"
  })))));
};
export { SvgPipeline02 as ReactComponent };